import { AccessorTypesEnum } from "./types";

export abstract class AccessorCondition {
  abstract type: AccessorTypesEnum

  abstract validate():Promise<boolean>
}
